<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12" v-if="realEstateId && realEstateId > 0 && realEstate && realEstate.coordination">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="pull-left">
                            <h4 class="card-title float-left">{{(realEstate && realEstate.name) ? realEstate.name : ''}}</h4>
                        </div>
                    </div>
                    <div class="card-body">
                        <template v-if="realEstate && realEstate.coordination">
                            <div class="row">
                                <div class="col-12 table-responsive">
                                    <div class="table-wrapper">
                                      <table class="table table-striped comparison-table" style="min-width: 900px">
                                          <tr class="bold-row">
                                              <td>Улушларни аниклашда бахоловчи куйидаги асосий омилларни тахлил килиши лозим</td>
                                              <td width="15%" class="text-center">Харажат ёндашув (Кхар) </td>
                                              <td width="15%" class="text-center">Киёсий ёндашув (Ккиёс)</td>
                                              <td width="15%" class="text-center">Даромад ёндашуви (Кдар)</td>
                                          </tr>
                                          <tr>
                                              <td>Тахлил ва хисоблашларга асос булган ахборотнинг ишончлилиги ва етарлилигини</td>
                                              <td class="text-center">{{calculated.expense.factor.analyzedInfoReliability | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.comparison.factor.analyzedInfoReliability | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.income.factor.analyzedInfoReliability | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          </tr>
                                          <tr>
                                              <td>Бахолаш ёндашуви бахолаш объектига хос булган нарх белгиловчи омиллар тузилишини хисобга олишга кодирлигини</td>
                                              <td class="text-center">{{calculated.expense.factor.comparisonsAndResultUseCoordination | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.comparison.factor.comparisonsAndResultUseCoordination | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.income.factor.comparisonsAndResultUseCoordination | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          </tr>
                                          <tr>
                                              <td>Ёндашув бахолаш объектига ўхшаш объектларнинг коида тарикасидаги харидорлари ва сотувчилари мотивациясини акс эттиришга кодирлигини</td>
                                              <td class="text-center">{{calculated.expense.factor.motivationReflectCapability | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.comparison.factor.motivationReflectCapability | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.income.factor.motivationReflectCapability | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          </tr>
                                          <tr>
                                              <td>Бахолаш ёндашуви хисобланаётган киймат турига мувофиклигини</td>
                                              <td class="text-center">{{calculated.expense.factor.objectTypeAndUsageCoordination | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.comparison.factor.objectTypeAndUsageCoordination | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.income.factor.objectTypeAndUsageCoordination | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          </tr>
                                          <tr>
                                              <td>Жами солиштирма ўлчовлар йиғиндиси</td>
                                              <td class="text-center">{{calculated.expense.factor.totalFactors | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.comparison.factor.totalFactors | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.income.factor.totalFactors | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          </tr>
                                          <tr>
                                              <td>Жами солиштирма  ўлчовлар (ўртача арифметиги)</td>
                                              <td class="text-center">{{calculated.expense.factorAverage | currency('', 4, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.comparison.factorAverage | currency('', 4, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.income.factorAverage | currency('', 4, { thousandsSeparator: ' ' })}}</td>
                                          </tr>
                                      </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 table-responsive">
                                    <div class="table-wrapper">
                                      <table class="table table-striped comparison-table" style="min-width: 900px">
                                          <tr>
                                              <th width="55%"></th>
                                              <th width="45%" colspan="3" class="text-center">Бино ва иншоатлар</th>
                                          </tr>
                                          <tr class="bold-row">
                                              <td>Ёндашувлар</td>
                                              <td width="15%" class="text-center">Харажат ёндашув</td>
                                              <td width="15%" class="text-center">Даромад ёндашув</td>
                                              <td width="15%" class="text-center">Қиёсий ёндашув</td>
                                          </tr>
                                          <tr>
                                              <td>Аниқланган қиймат</td>
                                              <td class="text-center">
                                                  <template v-if="calculated.approachCost">
                                                      {{calculated.expense.amount | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </template>
                                                  <template v-else>Қўлланилмаган</template>
                                              </td>
                                              <td class="text-center">
                                                  <template v-if="calculated.approachIncome">
                                                      {{calculated.income.amount | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </template>
                                                  <template v-else>Қўлланилмаган</template>
                                              </td>
                                              <td class="text-center">
                                                  <template v-if="calculated.approachComparative">
                                                      {{calculated.comparison.amount | currency('', 2, { thousandsSeparator: ' ' })}}
                                                  </template>
                                                  <template v-else>Қўлланилмаган</template>
                                              </td>
                                          </tr>
                                          <tr>
                                              <td>Солиштирма ўлчовлар коэффицентлари</td>
                                              <td class="text-center">{{Math.abs(calculated.expense.factorAverage) | currency('', 5, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{Math.abs(calculated.income.factorAverage) | currency('', 5, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{Math.abs(calculated.comparison.factorAverage) | currency('', 5, { thousandsSeparator: ' ' })}}</td>
                                          </tr>
                                          <tr>
                                              <td>Ўлчов қийматлари</td>
                                              <td class="text-center">{{calculated.expense.total | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.income.total | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                              <td class="text-center">{{calculated.comparison.total | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                          </tr>
                                          <tr>
                                              <td>Якуний микдорини аниклаш формуласи:</td>
                                              <td colspan="3" class="text-center">Кяк = Кхар * С1 + Кдар * С2 + Ккиёс * С3</td>
                                          </tr>
                                          <tr class="bold-row">
                                              <td>Бахолаш обектининг якуний микдори:</td>
                                              <td class="text-center" colspan="3">
                                                  {{calculated.total | currency('', 2, { thousandsSeparator: ' ' })}}
                                              </td>
                                          </tr>
                                      </table>
                                    </div>
                                </div>

                                <div class="col-12 mt-5 btns-box">
                                    <button class="all-btn delete-btn" v-if="!parentId" @click="cancel" :disabled="processing">{{$t("action.cancel")}}</button>
                                    <button class="all-btn add-btn" @click="save" :disabled="processing">{{$t("action.save")}}</button>
                                </div>
                            </div>
                        </template>
                        <div class="row" v-else>

                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="col-12">
                <div class="col-12">
                    <div class="text-center">
                        <span class="no-data mt-5 mb-5">{{$t("messages.list.empty")}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NewRealEstateCoordinationView",
        data() {
            return {
                processing: false,
                realEstateId: ((this.$route.params.id && this.$route.params.id > 0) ? this.$route.params.id : ((this.$route.params.hasOwnProperty('realEstateId') && this.$route.params.realEstateId) ? this.$route.params.realEstateId : null)),
                parentName: ((this.$route.params.hasOwnProperty('parentName') && this.$route.params.parentName) ? ('/' + this.$route.params.parentName + '/') : '/'),
                parentId: (this.$route.params.hasOwnProperty('realEstateId') && this.$route.params.realEstateId) ? this.$route.params.realEstateId : null,
                realEstate: {
                    name: '',
                    coordination: null,
                    status: ''
                }
            }
        },
        computed: {
            calculated() {
                // const coordination = this.realEstate.coordination;
                // coordination.expense.total = (coordination.approachCost ? (this.realEstate.coordination.expense.amount * this.realEstate.coordination.expense.factorAverage) : 0);
                // coordination.comparison.total = (coordination.approachComparative ? (this.realEstate.coordination.comparison.amount * this.realEstate.coordination.comparison.factorAverage) : 0);
                // coordination.income.total = (coordination.approachIncome ? (this.realEstate.coordination.income.amount * this.realEstate.coordination.income.factorAverage) : 0);
                // coordination.total = coordination.expense.total + coordination.comparison.total + coordination.income.total;

                return this.realEstate.coordination;
            }
        },
        methods: {
            init() {
               if (this.realEstateId && this.realEstateId > 0) {
                   const vm = this;
                   this.$http.get('admin/new-real-estate/coordination/' + this.realEstateId)
                       .then(res => {
                           // header
                           vm.realEstate = res.data;
                       }, err => {
                           console.log(err);
                       });
               }
            },
            cancel() {
                this.$router.push(this.parentName + 'new-real-estate/edit/' + this.realEstateId);
            },
            save() {
                this.processing = true;
                const isChangeStatus = this.$route.params.isChangeStatus;

                this.$http.post('admin/new-real-estate/coordination/' + this.realEstateId, this.calculated)
                    .then(res => {
                        console.log(res)
                      if (this.realEstate.status === "NotFullyEvaluated" && isChangeStatus && isChangeStatus === 'true') {
                        this.changeStatusGo('Evaluated');
                      } else if (!this.parentId) {
                        this.$router.push(this.parentName + 'new-real-estate/edit/' + this.realEstateId);
                      }
                        this.processing = false;
                    }).catch(({response}) => {
                      this.$swal({
                        type: 'error',
                        title: '',
                        text: response.data.message ? response.data.message : response.data
                      });
                      this.processing = false;
                    });
            },
            changeStatusGo(status) {
                const vm = this;
                this.processing = true;
                this.$http.post('admin/new-real-estate/status', {
                    realEstateId: this.realEstateId,
                    status: status,
                }).then(res => {
                    if (res && res.data && res.data.status === 'SUCCESS') {

                        vm.realEstate.status = status;
                        this.$swal({
                            title: this.$root.$t('messages.realEstate.reportWarning'),
                            text: this.$root.$t('messages.realEstate.appraiserReportSignEsp'),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#78b414',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Тасдиқлаш',
                            cancelButtonText: 'Бекор қилиш'
                        }).then((result) => {
                            if (result.value) {
                                if (status === 'Evaluated') {
                                    if (this.realEstate.hasEsp) {
                                        const {isEdit} = this.$route.query;
                                        this.$http.get(`esign/appraiser/${vm.realEstateId}/Building`)
                                            .then(res => {
                                                if (res.data && res.data.status === 'SUCCESS') {
                                                    window.open(res.data.data, '_blank');
                                                } else {
                                                    this.$swal({
                                                        title: this.$t('messages.common.error'),
                                                        text: res.data.message,
                                                        type: 'warning'
                                                    });
                                                }
                                            }, err => {
                                                console.log(err);
                                            });

                                        if (isEdit) {
                                            this.$router.push(this.parentName + 'new-real-estate/edit/' + vm.realEstateId);
                                        } else if (this.realEstate.category === 'Residential') {
                                            this.$router.push('/new-real-estate/residential');
                                        } else {
                                            this.$router.push('/new-real-estate/notorious');
                                        }

                                       /* this.$router.push({
                                            path: '/new-real-estate/appraiser-report/esp/' + vm.realEstateId,
                                            query: {version: 'V2'}
                                        }); */
                                    }
                                }
                            } else {
                                setTimeout(() => {
                                    this.$router.push(this.parentName + 'new-real-estate/edit/' + this.realEstateId);
                                },2000);

                                this.$swal({
                                    title: this.$root.$t('messages.common.success'),
                                    text: this.$root.$t('messages.realEstate.statusSuccess'),
                                    type: 'success'
                                });
                            }
                        })

                    } else {
                        this.$swal({
                            title: this.$root.$t('messages.common.warning'),
                            text: res.data && res.data.message ? res.data.message : this.$root.$t('messages.realEstate.statusWarning'),
                            type: 'warning'
                        }).then((result) => {
                            if (result.value) {
                                this.$router.push(this.parentName + 'new-real-estate/edit/' + this.realEstateId);
                            }
                        });
                    }
                    this.processing = false;
                }, () => {
                    this.$swal({
                        title: this.$root.$t('messages.common.error'),
                        text: this.$root.$t('messages.realEstate.statusError'),
                        type: 'error'
                    });
                    this.processing = false;
                });
            },
        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .comparison-table {
        font-size: 14px;
    }
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }
</style>